import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
  } from "@angular/core";
  import { ActivatedRoute, Router, Params } from "@angular/router";
  import { ModalController, ToastController } from "@ionic/angular";
  import { MatDialogRef } from "@angular/material/dialog";
  import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
  import { MasterService } from "src/app/services/master.service";
  import { CorrigendumRequestModel } from "src/app/model/CorrigendumRequestModel";
  import { CorrigendumUploadModel } from "src/app/model/CorrigendumUploadModel";
  import { MatSnackBar } from "@angular/material/snack-bar";
  import { TenementExchangeOtpModel } from "src/app/model/TenementExchangeOtpModel";
  import { LoginService } from "src/app/services/login.service";
import { ExtendAcceptanceService } from "src/app/services/extend-acceptance.Service";
import moment from "moment";
  
  @Component({
    selector: "app-modal",
    templateUrl: "./extend-data-modal.component.html",
    styleUrls: ["./extend-data-modal.component.scss"],
  })
  export class ExtendedAcceptanceModalComponent implements OnInit {
    key: number;
    base64File: string;
    public uploadedDocument: string;
    public uploadedDocumentTimestamp: Date;
    public isFileUploaded: boolean = false;
    form: FormGroup = new FormGroup({});
    selectedFile: File;
    corrigendumName: string = "";
    isLoading = false;
    CorrigendumResponseModel: CorrigendumUploadModel;
    corrigendumFileNameSelect: string;
    pageMode: string;
    corrigendumBase64: string;
    isOtpVerify: boolean = false;
    pageHead: string = "Login";
    maskMobileNumber: string;
    maskMobileNumberForFirstAppli: string;
    maskMobileNumberForSecondAppli: string;
    luser: TenementExchangeOtpModel = new TenementExchangeOtpModel();
    @Input() aceeptanceDate: any;
    @Input() surrenderDate: any;
    @Input() data: any;
  
    isSubmitDisabled: boolean = false;
    isResendOtpButtonVisible: boolean = false;
    resendOtpIn: any = null;
    timerOn = true;
    minDate: Date;
    currentDate: Date = new Date();

    @Output() dataModal = new EventEmitter<string>();
  
    constructor(
      private modalCtrl: ModalController,
      private extendAcceptanceService :ExtendAcceptanceService,
      private router: Router,
      private _snackBar: MatSnackBar,
      private route: ActivatedRoute,
    
    ) {
      this.minDate = moment(this.currentDate).add("day").toDate();
    }
  
    ngOnInit() {
      this.isSubmitDisabled = false;
      console.log("data", this.data);
      
      // const applicationNos = this.data.map(item => item.applicationNo).join(', ');

      // console.log(applicationNos);

      this.form = new FormGroup({
        acceptanceStartDate: new FormControl(null, [
          Validators.required,
         
        ]),
        acceptanceEndDate: new FormControl(null, [
          Validators.required,this.endDateAfterStartDate
        ]),
      });
    }

    endDateAfterStartDate(control: FormControl): { [key: string]: boolean } | null {
      const startDate = control.root.get('acceptanceStartDate')?.value;
      const endDate = control.value;
    
      if (startDate && endDate && endDate <= startDate) {
        return { endDateNotAfterStartDate: true };
      }
    
      return null;
    }

    saveAppliDetails() {
      const applicationNos = this.data.map(item => item.applicationNo).join(', ');
      console.log("this.form.value.acceptanceStartDate",this.form.value.acceptanceStartDate);
    
    
      // if (this.validateAccStartDate() && this.form.value.acceptanceStartDate) {
      //   this.extendAcceptanceService.errorToast(
      //     "Acceptance Start Date should be greater than Current Date"
      //   );
      // }

      let payload: any = {
        applicationNo: applicationNos,
        acceptanceStartDate:moment(this.form.value.acceptanceStartDate).format("DD-MMM-YY hh.mm.ss.SSSSSSSSS A"), 
        acceptanceEndDate:moment(this.form.value.acceptanceEndDate).format("DD-MMM-YY hh.mm.ss.SSSSSSSSS A"),
      };
  
      this.extendAcceptanceService
        .updateAcceptanceDtl(
          payload
        )
        .subscribe(
          (data: any) => {
            if (data.status == "SUCCESS") {
              this.onSaveApplicantDetails();
              this._snackBar.open("Date for Selected Application Updated Successfully", "Close", {
                horizontalPosition: "right",
                verticalPosition: "top",
                panelClass: "success-toast",
                duration: 3 * 1000,
              });
              
            }
            if (data.status == "FAILURE") {
              // console.log("Check data for failure", data);
               alert(data.errorMessage);
            }
          },
          (error) => {
            //alert("Invalid OTP");
            this._snackBar.open("Invalid username or password", "Close", {
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: "warning-toast",
              duration: 3 * 1000,
            });
          }
        );
    }
  
    cancel() {
      this.modalCtrl.dismiss(null, "cancel");
    }

    resetFilter() {
      // window.location.reload();
      this.modalCtrl.dismiss(null, "cancel");
    }
  
    back() {
      this.isOtpVerify = false;
      this.pageHead = "Login";
    }
  
    onSaveApplicantDetails() {
      this.modalCtrl.dismiss("submit");
      // console.log("modalCtrl", this.modalCtrl.dismiss("submit"));
    }
  
   
  
    async errorToast(errorMessage: string, dur?: number) {
      await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      });
    }
  
    async successToast(msg) {
      await this._snackBar.open(msg, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      });
    }
  
    get corrigendumDetails() {
      return this.form.get("corrigendumLst")["controls"];
    }

    validateAccStartDate() {
      return new Date(this.form.value.acceptanceStartDate) > new Date() 
        && new Date(this.form.value.acceptanceEndDate) < this.form.value.acceptanceStartDate
        ? true
        : false;
    }

  }
  